module.exports = __webpack_public_path__ + "img/o1.662f1597.png";